
module.exports = {
  // TODO: change your profile information here
  name: "Neetika Nigam",
  greeting: "Hey 👋",
  greetingDescription: "I'm Neetika Nigam and I'm a Final Year student of B.Tech major with Information technology!",
  githubUrl: "https://github.com/neetika6",
  linkedinUrl: "https://www.linkedin.com/in/neetika-nigam-246796175/",
  cvLink: "https://drive.google.com/file/d/151TWh8pjDVDANG4_Qp5TYGGSOCHzOXDZ/view?usp=sharing",
};
